const OPENING_KEY = "clk-dashboard-opening";

/** Set before landing → dashboard navigation so the app shell can keep showing the loader. */
export function markDashboardOpening() {
	try {
		sessionStorage.setItem(OPENING_KEY, "1");
	} catch {
		// private mode
	}
}

export function isDashboardOpening() {
	try {
		return sessionStorage.getItem(OPENING_KEY) === "1";
	} catch {
		return false;
	}
}

/** Hide the server-rendered loader once the React app shell is ready. */
export function dismissDashboardOpening() {
	try {
		sessionStorage.removeItem(OPENING_KEY);
	} catch {
		// ignore
	}

	document.documentElement.classList.remove("clk-dashboard-open-lock");

	const overlay = document.getElementById("clk-dashboard-open");
	if (!overlay || overlay.classList.contains("is-hidden")) {
		return;
	}

	overlay.classList.add("is-exit");
	window.setTimeout(() => {
		overlay.classList.add("is-hidden");
		window.setTimeout(() => {
			if (overlay.parentNode) {
				overlay.parentNode.removeChild(overlay);
			}
		}, 220);
	}, 180);
}
